var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import cs from '../_util/classNames';
import { ConfigConsumer } from '../ConfigProvider';
var Avatar = /** @class */ (function (_super) {
    __extends(Avatar, _super);
    function Avatar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // auto adjust font size
        _this.autoFixFontSize = function () {
            if (_this.textRef) {
                var size = _this.props.size;
                var textWidth = _this.textRef.offsetWidth;
                var scale = size / (textWidth + 8);
                _this.textRef.style.transform = "scale(" + (scale >= 2 ? 2 : scale) + ") translateX(-50%)";
            }
        };
        _this.renderAvatar = function (_a) {
            var getPrefixCls = _a.getPrefixCls;
            var _b = _this.props, className = _b.className, shape = _b.shape, size = _b.size, style = _b.style, children = _b.children, rest = __rest(_b, ["className", "shape", "size", "style", "children"]);
            var prefixCls = getPrefixCls('avatar');
            var classNames = cs(prefixCls, prefixCls + "-" + shape, className);
            var isText = children &&
                (typeof children === 'string' ||
                    (React.isValidElement(children) && children.type === 'span'));
            var isImage = children &&
                React.isValidElement(children) &&
                (children.type === 'img' || children.type === 'picture');
            return (React.createElement("div", __assign({}, rest, { style: __assign({ width: size, height: size, lineHeight: size + "px" }, style), className: classNames }),
                isText ? (React.createElement("span", { ref: function (ref) { return (_this.textRef = ref); }, className: prefixCls + "-text" }, children)) : null,
                isImage ? React.createElement("span", { className: prefixCls + "-image" }, children) : null));
        };
        return _this;
    }
    Avatar.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.size !== this.props.size || prevProps.children !== this.props.children) {
            this.autoFixFontSize();
        }
    };
    Avatar.prototype.componentDidMount = function () {
        this.autoFixFontSize();
    };
    Avatar.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderAvatar);
    };
    Avatar.displayName = 'Avatar';
    Avatar.propTypes = {
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        size: PropTypes.number,
        shape: PropTypes.oneOf(['circle', 'square']),
        style: PropTypes.object,
    };
    Avatar.defaultProps = {
        className: '',
        shape: 'circle',
        size: 40,
        style: {},
    };
    return Avatar;
}(PureComponent));
export default Avatar;
